import * as React from "react";
import TabSet from "../../../hiberUiKit/src/molecules/TabSet/TabSet";
import Tab from "../../../hiberUiKit/src/atoms/Tab/Tab";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import TabSetContent from "../../../hiberUiKit/src/molecules/TabSet/TabSetContent";
import {Option} from "ts-option";
import Note from "../../../model/note/Note";
import AccountingNoteTab from "../common/AccountingNoteTab";
import Invoice from "../../../model/invoice/Invoice";
import AccountingNote from "../../../model/invoice/note/AccountingNote";
import InvoicePaymentTab from "./InvoicePaymentTab";
import Payment from "../../../model/payment/Payment";
import {OnFailure, OnSuccess, OnSuccessData} from "../../../store/action/actionHelpers";

interface IProps {
	/**
	 * Invoice.
	 */
	invoice: Option<Invoice>;
	/**
	 * Note to edit.
	 */
	noteToEdit: Option<AccountingNote>;
	/**
	 * Add invoice note action.
	 * @param invoiceId
	 * @param content
	 * @param onSuccess
	 */
	addInvoiceNote: (invoiceId: string, content: string, onSuccess: OnSuccessData<AccountingNote>, onFailure: OnFailure) => void;
	/**
	 * Update invoice note action.
	 * @param noteId
	 * @param invoiceId
	 * @param content
	 * @param onSuccess
	 */
	updateInvoiceNote: (noteId: string,
		invoiceId: string,
		content: string,
		onSuccess: OnSuccessData<AccountingNote>,
		onFailure: OnFailure) => void;
	/**
	 * On edit note success callback.
	 */
	onUpdateNoteSuccess: () => void;
	/**
	 * Initial tab.
	 */
	selectedTabId?: InvoiceTab;
	/**
	 * On tab switch callback.
	 */
	onTabsSwitch?: (tabId: InvoiceTab) => void;
}

export default class InvoiceActivityTabs extends React.Component<IProps, {}> {
	render() {
		return (
			<React.Fragment>
				<TabSet>
					<Tab icon={Icon.Note} label={"Note"} tabId={InvoiceTab.Note}
						 selectedTabId={this.props.selectedTabId}
						 onClick={() => this.switchTab(InvoiceTab.Note)}/>
					{/* TODO: to be uncommented for ACCOPAYM-312 */}
					{/*{this.props.invoice.map(i => i.canPaymentBeAdded() &&*/}
					{/*<Tab icon={Icon.Finance} label={"Payments"} tabId={InvoiceTab.Payments}*/}
					{/*selectedTabId={this.props.selectedTabId}*/}
					{/*onClick={() => this.switchTab(InvoiceTab.Payments)}/>).orNull}*/}
				</TabSet>
				<TabSetContent isWhite={true}>
					{this.props.invoice.map(i => {
						const invoiceNoteTab: JSX.Element =
							<AccountingNoteTab noteToEdit={this.props.noteToEdit}
											   addNote={this.addNote}
											   updateNote={this.updateNote}/>;
						switch (this.props.selectedTabId) {
							case InvoiceTab.Note:
								return invoiceNoteTab;
							case InvoiceTab.Payments:
								return <InvoicePaymentTab invoiceId={i.id}/>;
							default:
								return invoiceNoteTab;
						}
					}).orNull}
				</TabSetContent>
			</React.Fragment>
		);
	}

	switchTab = (tabId: InvoiceTab) => {
		this.props.onTabsSwitch && this.props.onTabsSwitch(tabId);
	};

	addNote = (content: string, onSuccess: OnSuccessData<AccountingNote>, onFailure: OnFailure) =>
		this.props.invoice.map(i => this.props.addInvoiceNote(i.id, content, onSuccess, onFailure));

	updateNote = (noteId: string,
		content: string,
		onSuccess: OnSuccess,
		onFailure: OnFailure) =>
		this.props.invoice.map(i => {
			const successCallback = (note: AccountingNote) => {
				this.props.onUpdateNoteSuccess();
				onSuccess();
			};
			this.props.updateInvoiceNote(noteId, i.id, content, successCallback, onFailure)
		});
}

export enum InvoiceTab {
	Note = "note",
	Payments = "payments"
}
